import { toast } from 'react-hot-toast';

import { useQuery } from '@tanstack/react-query';

import { getBrandStrategy } from '../services';
import { useBrandStrategyStore } from '../store/brand-strategy-store';
import { createStableQueryOptions } from '../utils/query-options';

export const useBrandStory = (projectId: string) => {
  const { setBrandStrategyId, setBrandStrategy } = useBrandStrategyStore();
  const fields =
    'why_start_the_business,unique_industry_perspective,proudest_moment_in_business,purpose,mission,vision';

  return useQuery({
    queryKey: ['brand-story', projectId],
    queryFn: async () => {
      try {
        const response = await getBrandStrategy(projectId, fields);
        const brandStrategy = response.data;

        // Store the brand strategy ID and data in the store
        if (brandStrategy?.id) {
          setBrandStrategyId(brandStrategy.id);
          setBrandStrategy(brandStrategy);
        }

        return response;
      } catch (error) {
        toast.error('Failed to fetch getting to know you');
        throw error;
      }
    },
    enabled: !!projectId,
    ...createStableQueryOptions(),
  });
};
